import { atom } from "recoil";

export type GenCouponType = {
  type: number; // 0: 관리자 테스트 주문, 1: 온보딩
  name: string;
  description: string | null;
  price: number;
  issue_limit_count: number;
  min_order_price: number;
  can_duplicate: boolean;
};

export const couponState = atom<GenCouponType | null>({
  key: "coupon",
  default: null,
});
